import { PriceType } from '@/app/shared/types/common';

export enum LeaderboardTypeFilter {
  RANK = 'rank',
  COOKIE = 'cookie',
  TON = 'ton',
  XP = 'xp',
}

export type LeaderboardSortTypeFilter = 'top' | 'createdAt';
export type LeaderboardSortOrderFilter = 'asc' | 'desc';

export interface LeaderboardFilters {
  type: LeaderboardTypeFilter;
  isMyTeam: boolean;
  sortType: LeaderboardSortTypeFilter;
  sortOrder: LeaderboardSortOrderFilter;
  page?: number;
  limit?: number;
}

export interface LeaderboardUserProfile {
  fullName: string | null;
  avatar: string | null;
  activitiesScope: string | null;
}

export interface LeaderboardUserProgress {
  level: number;
  total_xp: number;
}

export interface LeaderboardUserFinance {
  cookieWeeklyIncome: string;
  tonWeeklyIncome: string;
}

export interface LeaderboardUser {
  id: number;
  telegramUsername: string | null;
  profile: LeaderboardUserProfile | null;
  progress: LeaderboardUserProgress | null;
  finance: LeaderboardUserFinance | null;
}

export interface Leaderboard {
  users: LeaderboardUser[];
  total: number;
  page: number;
  limit: number;
  hasMore: boolean;
}

export interface MyUserFilters {
  type?: PriceType;
}

export interface MyUser {
  user: LeaderboardUser;
  position: number;
}
